/**
 * Rôles Keycloak par section de la configuration v2, repris des pages
 * équivalentes de l'ancien front : /config/users (manage_user),
 * /config/regions (manage_area), /sites + /site-setup (manage_site),
 * le lien Setup organization (org_manager) et le catalogue produits /
 * fournisseurs de /region-setup (droits produit et fournisseur).
 *
 * Fichier volontairement sans dépendance : il est aussi importé par la
 * nav-bar (chunk principal) sans embarquer le chunk lazy de la configuration.
 */
export const CONFIG_SECTION_ROLES = {
  organization: ['org_manager'],
  areas:        ['manage_area'],
  sites:        ['manage_site'],
  users:        ['manage_user'],
  catalog:      ['manage_product', 'view_all_product', 'manage_provider'],
  warehouses:   ['org_manager'],
} as const;

/** Union des rôles de section : gouverne l'accès global à /new_config. */
export const CONFIG_ROLES: string[] = [...new Set(Object.values(CONFIG_SECTION_ROLES).flat())];
